<template>
<div class="main_view" id="main_view">
        <div
            v-show="doc_view == 'home'"
            id="toca-wiki-ai-entry"
            style="z-index: 100"
        ></div>
        <div
            class="home_view"
            v-if="
                doc_view == 'home' ||
                    doc_view == 'emptyfile' ||
                    doc_view == 'noauth' ||
                    doc_view == 'history'
            "
        >
            <Directory
                :docId="doc_id"
                @gotoSearch="gotoSearch"
                @gotoAISearch="gotoAISearch"
                @foldKBDir="foldKBDir"
                @starFile="starFile"
                @unstarFile="unstarFile"
                @getMoreAuth="getMoreAuth"
                @moveFile="moveFile"
                @createCopy="createCopy"
                @updateBreadcrumb="updateBreadcrumb"
                ref="fileDirectory"
            />

            <div
                class="render_view"
                v-if="doc_view == 'home' || doc_view == 'history'"
            >
                <OtherView
                    v-if="doc_type == 'DOCUMENT' && edit_doc_type != 'NORMAL'"
                    @submit_password="checkFileAuth"
                />
                <Edit
                    ref="editRef"
                    v-if="isDocType"
                    @gotoRoute="gotoRoute"
                    @deleteFile="deleteFile"
                    @createFileWithTemplate="showCreateFileWithTemplateDialog"
                    @moveFile="moveFile"
                    @createCopy="createCopy"
                    @onSelectionUpdate="onSelectionUpdate"
                />
                <TencentDocWrap
                    v-show="isTencentDoc"
                    ref="tencentDocRef"
                    @gotoFile="gotoTencentDocRoute"
                    @deleteFile="deleteFile"
                    @gotoUseTemplate="gotoUseTemplate"
                    @saveFileFinished="saveFileFinished"
                    @moveFile="moveFile"
                    @createCopy="createCopy"
                />
                <NoPreview v-if="doc_type == ''" />
                <div class="loading_view" v-if="doc_type == 'LOADING'"></div>
            </div>
            <NoFile v-if="doc_view == 'emptyfile'" />
            <NoAuth v-if="doc_view == 'noauth'" />
        </div>
        <div
            v-show="doc_view == 'home'"
            id="toca-wiki-ai-chat"
            style="height: 100vh; z-index: 1000"
        ></div>

        <div class="setting_view" v-if="doc_view == 'setting'">
            <SettingView :wikiSpaceId="wikiSpaceInfo.wikiSpaceId" />
        </div>
        <div class="trash_view" v-if="doc_view == 'trash'">
            <TrashView />
        </div>
        <div class="no_kb_view" v-if="doc_view == 'empty'">
            <KbDelte />
        </div>
        <!-- <div class="loading_view" v-if="doc_view == 'loading'">
            <Loading />
        </div> -->
        <div class="history_view" v-if="doc_view == 'history'">
            <History />
        </div>
        <!-- 普通搜索 -->
        <div
            v-if="showSearch"
            id="toca_doc_search"
            class="toca_doc_search"
        ></div>
        <!-- AI 搜索 -->
        <a-modal
            class="ai-search-dialog"
            modal-animation-name=""
            :body-style="{ height: '100%' }"
            v-model:visible="showAISearch"
            :simple="true"
            :footer="false"
            :render-to-body="true"
            @before-close="closeAISearch"
            :unmount-on-close="true"
        >
            <div class="full-width full-height toca-wiki-ai-search">
                <div class="full-height" id="toca-wiki-ai-search"></div>
            </div>
        </a-modal>
        <div
            v-if="isShowFolderOperationDialog"
            id="toca_folder_operation_dialog"
            class="toca_folder_operation_dialog"
        ></div>
        <div v-if="isNotInToca" id="tocaWow"></div>
    </div>
</template>

<script lang="ts">
import { intl } from 'tci18n-vue3'
import { mapActions, mapState, mapGetters } from 'vuex';
import Directory from '../components/kbdir/Directory.vue';
import Edit from '../components/kbedit/Edit.vue';

import TencentDocWrap from '../components/wps/WpsWrap.vue';
import {
getKBTreeNode,
kbCreateFile,
getKBInfo,
getFileYjsData,
kbDirMove,
kbCreateCopy,
createFileCopy } from
'../core/api/file';
import SettingView from './setting/SettingView.vue';
import TrashView from './Trash.vue';
import KbDelte from '../components/otherview/KbDelte.vue';
import NoFile from '../components/otherview/NoFile.vue';
import NoAuth from '../components/otherview/NoAuth.vue';

import NoPreview from '../components/otherview/NoPreview.vue';
import { getNodeInfo } from '../store/kbTreeNodeModule';
import { HocuspocusModule } from '../store/types';

import FileSocket, { FileSocketResp } from '../core/api/FileSocket';
import { changeLinkIcon } from '../utils/changeLinkIcon';
import Loading from '../components/Loading.vue';
import { checkFileAuth, recheckFile, getRuntimePassword } from '../utils/checkAuth';
import { waitFileCopyTaskComplete } from '../core/utils/fileCopyTask';
import OtherView from '../components/otherview/OtherView.vue';
import History from './History.vue';

import { getBrowser } from '@/utils/browser';
import {
updateSaviorData,
saviorEventUUID,
setSaviorConfigure } from
'@/utils/savior';
import { store } from '../store/store';
import UrlRouterUtil from '@/utils/UrlRouterUtil';
import { templateDetail, kbCreateDocumentFile } from '../core/api/file';
import { debounce } from '@/utils/lodash';
// import { TocaFolderOperationDialog } from '@toca/toca-wiki-template';
import { TocaFolderOperationDialog } from '@toca/toca-folder-operation-dialog';
import '@toca/toca-folder-operation-dialog/dist/style.css';
import { showAiEntry } from '@/utils/AIUtils';
import { checkFile } from '../core/api/file';
import { finishDocumentLoad, startDocumentLoad } from '@/utils/sentry';

export default {
  name: 'main_view',
  components: {
    Directory,
    Edit,
    TencentDocWrap,
    SettingView,
    TrashView,
    KbDelte,
    NoFile,
    NoAuth,
    NoPreview,
    Loading,
    OtherView,
    History },

  data() {
    return {
      aiEntry: null,
      aiChat: null,
      aiSearchChat: null,
      checkFileAuth: checkFileAuth,
      loading: true,
      noKbSpace: false,
      emptySpace: false,
      fileSocket: null,
      tocaWow: null,
      showSearch: false,
      showAISearch: false,
      tocaSearch: null,
      folderOperationDialog: null,
      isShowFolderOperationDialog: false };

  },
  created() {
    console.timeEnd('time1111111111111Router');
    document.body.style.overscrollBehaviorX = 'none';
    this.startFieSocket();
  },
  mounted() {
    document.getElementById('loading')?.remove();
    const params = new URL(location.href).searchParams;
    const paramFid = params.get('fid');
    this.initDir(paramFid);
    this.loadWow();
  },
  watch: {
    doc_info: {
      deep: true,
      handler(val) {
        //文件信息变化
        console.log('doc_infodoc_info', val);
        //重新检查权限根据权限检查决定如何显示
        recheckFile(val);
        this.handleAi(true);
      } },

    wikiSpaceInfo: {
      handler(val) {
        if (val) {
          this.handleAi(true);
        }
      },
      deep: true },

    doc_id: {
      handler(val) {
        if (val !== null) {
          this.checkFileAuth();

          this.startFieSocket();
        }
      },
      deep: true },

    doc_type: {
      handler(val) {
        if (this.doc_id !== null && val) {
          startDocumentLoad(this.doc_id, val, {
            fileName: this.doc_info?.fileInfo?.fileName,
            wikiSpaceId: this.wikiSpaceInfo?.wikiSpaceId,
            showtype: this.showtype });

        }
      },
      immediate: true },

    edit_doc_type: {
      handler(val) {
        if (val && val !== 'NORMAL' && val !== 'LOADING' && this.doc_id !== null) {
          finishDocumentLoad(
          val === 'DELETEFILE' || val === 'EXPIREFILE' ? 'error' : 'success',
          this.doc_id,
          this.doc_type);

        }
      },
      immediate: true },

    faviconUrl: {
      handler(val) {
        console.log('faviconUrlfaviconUrlfaviconUrl', val);
        changeLinkIcon(val);
      },
      immediate: true },

    tocaEditor: {
      handler(val) {
        if (val) {
          this.handleAi(true);
        }
      },
      immediate: true } },


  computed: {
    ...mapState({
      edit_doc_type: (state) => state.kbEditModule.edit_doc_type,
      doc_id: (state) => state.kbModule.doc_id,
      doc_info: (state) => state.kbEditModule.doc_info,
      doc_type: (state) => state.kbModule.doc_type,
      doc_view: (state) => state.kbModule.doc_view,
      treeNodes: (state) => state.kbTreeNodeModule.treeNodes,
      userId: (state) => state.userModule.userId,
      spaceId: (state) => state.userModule.spaceId,
      wikiI18n: (state: any) => state.kbModule.wikiI18n,
      dialogType: (state) => state.kbDialogModule.dialogType,
      wikiSpaceInfo: (state) => state.kbTreeNodeModule.wikiSpaceInfo,
      tocaEditor: (state) => state.kbEditModule.tocaEditor,
      showtype: (state) => state.kbModule.showtype }),


    ...mapGetters({
      faviconUrl: 'kbModule/faviconUrl',
      isCanAddFirstLevel: 'kbTreeNodeModule/isCanAddFirstLevel',
      isAdmin: 'kbTreeNodeModule/isAdmin' }),

    isTencentDoc() {
      return (
        this.doc_type == 'PPT' ||
        this.doc_type == 'EXCEL' ||
        this.doc_type == 'WORD' ||
        this.doc_type == 'PDF' ||
        this.doc_type == 'TXT' ||
        this.doc_type == 'SMART_SHEET' ||
        this.doc_type == 'FLOW_CHART' ||
        this.doc_type == 'MIND' ||
        this.doc_type == 'BOARD');

    },
    currentWikiSpaceId() {
      return this.wikiSpaceInfo?.wikiSpaceId;
    },
    isNotInToca() {
      return getBrowser().isInTocaApp === false;
    },
    isDocType() {
      return this.doc_type === 'DOCUMENT' && this.edit_doc_type === 'NORMAL';
    } },

  methods: {
    showAiEntry() {
      let isHomePage = this.doc_view === 'home' ? true : false;
      if (!isHomePage) return;
      return showAiEntry(
      this.showtype,
      this.doc_info.fileInfo?.contentType,
      this.doc_info.auth,
      isHomePage);

    },
    destroyAi() {
      this.aiEntry?.destroy();
      this.aiChat?.destroy();
      document.getElementById('toca-wiki-ai-chat-container')?.remove();
      document.getElementById('toca-wiki-ai-entry-container')?.remove();
      this.aiEntry = null;
      this.aiChat = null;
    },
    handleAi(isChangeDoc = false) {
      if (!(this.wikiSpaceInfo && this.doc_info)) {
        return;
      }
      this.destroyAi();
      // }
      if (this.showAiEntry() === true) {
        try {
          this.loadWikiAiChat();
          this.loadWikiAiEntry();
        } catch (error) {
          console.error(intl.$t("加载AI组件失败"), error);
        }
      }
    },
    onSelectionUpdate(content: any) {
      if (this.aiEntry) {
        this.aiEntry?.onSelectionUpdate(content);
      }
    },
    loadWikiAiEntry() {
      const cookies = {
        token: store.state.userModule.token,
        spaceId: store.state.userModule.spaceId,
        userId: store.state.userModule.userId,
        deviceId: store.state.userModule.deviceId,
        memberUniqueId: store.state.userModule.userDetail?.id,
        memberId: store.state.userModule.userDetail?.id };


      const container = document.getElementById('toca-wiki-ai-entry');
      //先执行这一行，必须先拿到cookies
      this.aiEntry = new TocaWikiAiEntry(container, cookies, {
        locale: this.wikiI18n });


      // 只能识别这个元素<toca-wiki-ai-entry></toca-wiki-ai-entry>
      const app = document.createElement('toca-wiki-ai-entry');
      app?.setAttribute('id', 'toca-wiki-ai-entry-container');
      container?.appendChild(app);
      // @ts-ignore
    },
    loadWikiAiChat() {
      const container = document.getElementById('toca-wiki-ai-chat');
      // 只能识别这个元素<toca-wiki-ai-chat></toca-wiki-ai-chat>
      const app = document.createElement('toca-wiki-ai-chat');
      app?.setAttribute('id', 'toca-wiki-ai-chat-container');
      // @ts-ignore
      this.aiChat = new TocaWikiAiChat(container, {
        env: import.meta.env.MODE,
        wikiSpaceId: this.wikiSpaceInfo.wikiSpaceId,
        documentId: this.doc_id,
        tocaEditor: this.tocaEditor,
        locale: this.wikiI18n,
        saviorEventUUID: saviorEventUUID,
        setSaviorConfigure: setSaviorConfigure,
        updateSaviorData: updateSaviorData,
        supportDocInteraction: this.doc_type === 'DOCUMENT',
        sourceFrom: this.doc_type,
        aiChatShow: (isShow: Boolean) => {
          this.setShowAiChat(isShow);
        },
        contentElement: document.querySelector('.main_view') });


      container.appendChild(app);
    },
    gotoTencentDocRoute(fileId: string) {
      console.log('------------------------点击目录', fileId);
      this.$refs.fileDirectory.selectNode(fileId);
    },
    moveFile(data) {
      this.isShowFolderOperationDialog = true;
      setTimeout(() => {
        const params = {
          sourceType: 'WIKI',
          operationType: 'MOVE',
          targetTypes: ['WIKI'],
          sourceFileData: data,
          userInfo: { userId: this.userId, spaceId: this.spaceId },
          sourceWikiSpaceId: this.wikiSpaceInfo.wikiSpaceId,
          locale: this.wikiI18n,
          env: import.meta.env.MODE,
          onCancel: () => {
            this.isShowFolderOperationDialog = false;
          },
          onSelectFile: (data) => {
            this.confirmMove(data);
          } };

        this.folderOperationDialog = new TocaFolderOperationDialog(
        '#toca_folder_operation_dialog',
        params);

      }, 0);
    },
    updateBreadcrumb() {
      if (this.$refs.editRef) {
        this.$refs.editRef.updateBreadcrumb();
      }
      if (this.$refs.tencentDocRef) {
        this.$refs.tencentDocRef.sendMessageToTencentDoc('updateBreadcrumb');
      }
    },
    async confirmMove(data) {
      try {
        const sourceFileData = data.sourceFileData;
        const selectedNode = data.selectedNode;
        const selectedProductType = data.selectedProductType;
        const res = await kbDirMove(
        sourceFileData.fileId,
        selectedNode.fileId,
        '1');

        const { code, message } = res.data;
        if (code === 200) {
          if (
          selectedProductType !== 'WIKI_FILE' ||
          sourceFileData.fileId === this.doc_id && selectedNode.wikiSpaceId !== this.currentWikiSpaceId)
          {
            // 跨品类转移 or (当前文件跨知识库转移），直接刷新页面
            window.location.reload();
          } else {
            // 同一知识库内转移，刷新目录树并选中转移后的文件
            const res = await getKBTreeNode(this.doc_id);
            const { code, data, message } = res.data;
            if (code == 200) {
              store.dispatch('kbTreeNodeModule/setTreeNodeData', data);
              store.dispatch('kbModule/setWikiSpaceInfo', data.wikiSpaceInfo);
              this.refreshDirExp();
              this.updateBreadcrumb();
            }
            this.$message.success({ content: intl.$t("移动成功，页面已继承新父页面的权限") });
            this.isShowFolderOperationDialog = false;
          }

        } else {
          this.$message.error({ content: intl.$t("移动失败") });
          console.error(message);
        }
      } catch (error) {
        this.$message.error({ content: intl.$t("移动失败") });
      }
    },
    async createCopy(data) {
      //检查文件权限先加载loading
      let doc_id = store.state.kbModule.doc_id;
      let needPassword = getRuntimePassword(`${doc_id}`);
      const res: any = await checkFile(doc_id + '', needPassword);
      if (res.data?.code === 200) {
        const riskType = res.data?.data?.riskType;
        const fileInfo = res.data?.data?.fileInfo;
        const isRiskType = riskType === 'HIGH' || riskType === 'MEDIUM' || riskType === 'LOW';
        const createUserId = fileInfo?.creatorInfo?.userId;
        if (isRiskType === true && this.userId !== createUserId && !this.isAdmin) {
          let userName = fileInfo?.creatorInfo?.userName;
          let employeeNo = fileInfo?.creatorInfo?.employeeNo;
          if (userName && userName.length > 0 && employeeNo && employeeNo.length > 0) {
            userName = userName + '(' + employeeNo + ')';
          }
          this.$message.error(intl.$t(`该文档存在潜在安全风险，暂不支持使用，请联系文档所有者 {userName} 处理`, { userName: userName }));
          return;
        }
      }
      const cookies = {
        token: store.state.userModule.token,
        spaceId: store.state.userModule.spaceId,
        userId: store.state.userModule.userId,
        deviceId: store.state.userModule.deviceId,
        memberUniqueId: store.state.userModule.userDetail?.id,
        memberId: store.state.userModule.userDetail?.id };

      this.isShowFolderOperationDialog = true;
      setTimeout(() => {
        const params = {
          sourceType: 'WIKI',
          operationType: 'CREATE_COPY',
          targetTypes: ['MY_DOC', 'SHARE_TO_ME', 'WIKI'],
          sourceFileData: data,
          userInfo: cookies,
          sourceWikiSpaceId: this.wikiSpaceInfo.wikiSpaceId,
          locale: this.wikiI18n,
          env: import.meta.env.MODE,
          onCancel: () => {
            this.isShowFolderOperationDialog = false;
          },
          onSelectFile: (data) => {
            this.gotoCreateCopy(data);
          } };


        this.folderOperationDialog = new TocaFolderOperationDialog(
        '#toca_folder_operation_dialog',
        params);

      }, 0);
    },
    deleteFile(fileId: string) {
      this.$refs.fileDirectory.wpsDeleteFile(fileId);
    },
    gotoUseTemplate(templateId: string) {
      this.showCreateFileWithTemplateDialog(templateId);
    },
    saveFileFinished(data) {
      let dataResult = JSON.parse(data);
      this.confirmCreate(dataResult);
    },
    gotoCreateCopy(data) {
      let sourceFileData = data.sourceFileData;
      if (this.doc_id === sourceFileData.fileId) {
        //当前文件进行拷贝
        if (this.doc_info.fileInfo.contentType === 'DOCUMENT') {
          window['tocaEditor']?.saveDocument(
          debounce((result: boolean) => {
            this.confirmCreate(data);
          }, 100));

        } else {
          this.$refs.tencentDocRef.sendMessageToTencentDoc({
            type: 'handleSave',
            data: JSON.stringify(data, this.customStringifyReplacer) });

        }
      } else {
        this.confirmCreate(data);
      }
    },
    customStringifyReplacer(key, value) {
      // 如果发现对象是循环引用，则返回 undefined
      if (key === 'parent' || key === 'children') return undefined;
      return value;
    },
    async confirmCreate(data) {
      const selectedProductType = data.selectedProductType;
      const sourceFileData = data.sourceFileData;
      const selectedNode = data.selectedNode;
      const createNameText = data.createNameText;
      const fileName = sourceFileData.fileName || '';
      let suffix = fileName.includes(".") ? fileName.slice(fileName.lastIndexOf(".") + 1) : "";
      if (sourceFileData.contentType === 'DOCUMENT') {
        suffix = '';
      } else {
        suffix = suffix.length > 0 ? '.' + suffix : '';
      }
      updateSaviorData({
        eventtype: 'click',
        category: 'wiki_createdialog',
        label: 'more_doc_copy',
        eventid: 'wiki_web_operation',
        value: {
          currentParentPath: data.sourceFileData?.parentId,
          targetPath: data.selectedNode?.fileId } });


      try {
        if (selectedProductType === 'WIKI_FILE') {
          const res = await kbCreateCopy(sourceFileData.fileId, selectedNode.fileId, createNameText + suffix);
          const { code, message, data: copyResult } = res.data;
          if (code === 200) {
            const fileInfo = await waitFileCopyTaskComplete(copyResult);
            const fileId = fileInfo.fileId;
            const contentType = sourceFileData.contentType;
            if (this.currentWikiSpaceId !== selectedNode.wikiSpaceId) {
              if (fileInfo.fileUrl) {
                window.open(fileInfo.fileUrl, '_blank');
              }
            } else {
              const res = await getKBTreeNode(fileId);
              const { code, data, message } = res.data;
              if (code == 200) {
                store.dispatch('kbTreeNodeModule/setTreeNodeData', data);
                store.dispatch('kbModule/setWikiSpaceInfo', data.wikiSpaceInfo);
                store.dispatch('kbModule/setDocType', contentType);
                this.refreshDirExpAndSelect(fileId);
              }
            }
            this.$message.success({ content: intl.$t("创建副本成功") });
            this.isShowFolderOperationDialog = false;
          } else {
            this.$message.error({ content: message || intl.$t("创建副本失败") });
            console.error(message);
          }
        } else if (selectedProductType === 'CLOUD_DOCUMENT') {
          const res = await createFileCopy(sourceFileData.fileId, createNameText + suffix, selectedNode.fileId);
          const { data: copyResult, code, message } = res.data;
          if (code === 200) {
            const fileInfo = await waitFileCopyTaskComplete(copyResult);
            if (fileInfo.fileUrl) {
              window.open(fileInfo.fileUrl, '_blank');
            }
            this.$message.success({ content: intl.$t("创建副本成功") });
            this.isShowFolderOperationDialog = false;
          } else {
            this.$message.error({ content: message || intl.$t("创建副本失败") });
          }
        }
      } catch (error) {
        const errorMessage = error instanceof Error ? error.message : intl.$t("创建副本失败");
        this.$message.error({ content: errorMessage || intl.$t("创建副本失败") });
        console.error(error);
      }
    },
    customStringifyReplacer(key, value) {
      // 如果发现对象是循环引用，则返回 undefined
      if (key === 'parent' || key === 'children') return undefined;
      return value;
    },
    refreshDirExpAndSelect(fileId) {
      this.$refs.fileDirectory.refreshDirExpAndSelect(fileId);
    },
    gotoRoute(item: any) {
      console.log('------------------------点击目录', item);
      if (getBrowser().isInTocaApp === true) {
        const origin = window.location.origin;
        UrlRouterUtil.openUrl(
        origin + `/wiki?fid=${item.fileId}`,
        '_self');

        return;
      } else {
        this.$refs.fileDirectory.selectNode(item.fileId);
      }
    },
    refreshDirExp() {
      this.$refs.fileDirectory.refreshDirExp();
    },
    refreshDirExpAndSelect(id) {
      this.$refs.fileDirectory.refreshDirExpAndSelect(id);
    },
    startFieSocket() {
      if (this.fileSocket !== null) {
        this.fileSocket.wsClose();
        this.fileSocket = null;
      }
      const that = this;
      this.fileSocket = new FileSocket({
        params: {
          spaceId: this.spaceId,
          userId: this.userId,
          fid: this.doc_id },

        onMessage(arg: FileSocketResp) {
          that.onReceiveStatelessMsg(arg);
          that.handleSocketMessage(arg);
        },
        onSuccess() {
          console.log('111111111111');
        } }).
      init();
    },
    async handleSocketMessage(arg: FileSocketResp) {
      if (arg.eventType === 'FILE_RENAMED') {
        this.updateSelectDocName(arg.eventBody);
      } else if (arg.eventType === 'AUTH_CHANGED') {
        // if (this.doc_info?.fileInfo?.contentType)
        //     this.setDocType(this.doc_info.fileInfo.contentType);
        if (this.doc_info.fileInfo.contentType == 'DOCUMENT') {
          //ppt or excel本身弹了
          this.showAuthTipMsg(arg);
          // const { auth } = arg.eventBody;
          // if (!(auth === 'ALL' || auth === 'WRITE')) {
          //     window['tocaEditor']?.setIsCanEdit(false);
          //     let docInfo = this.doc_info;
          //     docInfo.auth = arg.eventBody.auth;
          //     docInfo.fileInfo.auth = arg.eventBody.auth;
          //     window['tocaEditor']?.updateDocInfo(docInfo);
          // }
        }
        //修改选中文件的auth
        // this.updateSelectDocAuth(arg.eventBody);

        //修改编辑器文档的auth
        setTimeout(() => {
          if (getBrowser().isInTocaApp === true) {
            window.open(window.location.href, '_self');
          } else {
            window.location.reload();
          }
        }, 1000);
      } else if (arg.eventType === 'FILE_DELETED') {
        let fileId = arg.eventBody.fileId;
        if (fileId && fileId.length > 0) {
          this.$refs.fileDirectory.handleDeleteFile(fileId, true);
        }
      } else if (arg.eventType === 'FILE_TRANSFERRED') {
        let fileId = arg.eventBody.fileId;
        // 转移文件权限
        this.$message.success(intl.$t("转移所有权成功"));
        // 更新文档创建人
        // window['tocaEditor']?.getDocInfoFromServer(fileId);
        // 434 - 转移所有权限后，重刷页面
        setTimeout(() => {
          if (getBrowser().isInTocaApp === true) {
            window.open(window.location.href, '_self');
          } else {
            window.location.reload();
          }
        }, 400);
        // 原本的socket导出逻辑，先保留
        // } else if (arg.eventType === 'EXPORT_PDF') {
        //     try {
        //         const {
        //             deviceId,
        //             downloadId,
        //             fileId,
        //             fileName
        //         } = arg.eventBody;
        //         if (this.containDownloadId(downloadId)) {
        //             await downloadPDFAPI(
        //                 fileId,
        //                 downloadId,
        //                 fileName,
        //                 {
        //                     userId: this.userId,
        //                     spaceId: this.spaceId,
        //                     token: store.state.userModule.token,
        //                     deviceId: deviceId
        //                 },
        //                 this.$message
        //             );
        //             this.removeDownloadIds(downloadId);
        //             this.$message.clear();
        //         }
        //     } catch (err) {
        //         this.$message.error('文件生成失败');
        //     }
      } else if (arg.eventType === 'WIKI_SPACE_SETTINGS_CHANGED') {
        // 兼容组织人才，编辑过程中，后端设置知识库只能只读逻辑
        const { readOnly } = arg.eventBody;
        const kbSetreadOnly =
        store.state.kbModule?.wikiSpaceInfo?.wikiSpaceSettings?.
        readOnly;
        if (readOnly !== kbSetreadOnly) {
          window.location.reload();
        }
      } else if (arg.eventType === 'URL_AUTH_CHANGED') {
        const auth = arg.eventBody.auth;
        const scope = arg.eventBody.scope;
        const fileId = arg.eventBody.fileId;
        if (this.$refs.editRef) {
          this.$refs.editRef.updateLinkShareInfo(auth, scope, fileId);
        }
      } else if (arg.eventType === 'FILE_RISK_CHANGED') {
        const { riskType } = arg.eventBody;
        this.handleRiskTypeChange(riskType);
      } else if (arg.eventType === 'PERMISSION_SETTINGS_CHANGED') {
        const fileId = arg.eventBody.fileId;
        const { auth } = this.doc_info;
        if (fileId === this.doc_id && auth !== 'ALL') {
          if (this.doc_info.fileInfo.contentType == 'DOCUMENT') {
            this.$message.info(intl.$t("你在此文档的复制权限发生变更"));
          }
          setTimeout(() => {
            if (getBrowser().isInTocaApp === true) {
              window.open(window.location.href, '_self');
            } else {
              window.location.reload();
            }
          }, 1000);
        }
      }
    },
    handleRiskTypeChange(riskType) {
      // 判定是否是为包含敏感信息的高风险页面（非所有者查看提示缺省页，所有者查看提示顶部横幅（SensitiveContentTips））
      const creatorId = this.doc_info?.fileInfo?.creatorInfo?.userId;
      const userId = store.state.userModule.userId;
      const isAdmin = store.getters['kbTreeNodeModule/isAdmin'];
      if (riskType === 'HIGH' || riskType === 'MEDIUM' || riskType === 'LOW') {
        if (creatorId === userId || isAdmin === true) {
          if (this.$refs.editRef) {
            this.$refs.editRef.setSensitiveTipsStatus(2);
          }
          store.dispatch('sensitiveContentInfoModule/setShowSensitiveContentTips', true);
        } else {
          const employeeNo = this.doc_info?.fileInfo?.creatorInfo?.employeeNo || '';
          store.dispatch('sensitiveContentInfoModule/setCreator', this.doc_info?.fileInfo?.creator + (employeeNo ? `(${employeeNo})` : ''));
          store.dispatch('kbModule/setDocType', 'DOCUMENT');
          store.dispatch('kbEditModule/setEditDocType', 'SENSITIVEBLOCKED');
          return;
        }
      } else {
        store.dispatch('sensitiveContentInfoModule/setShowSensitiveContentTips', false);
        if (this.edit_doc_type === 'SENSITIVEBLOCKED') {
          this.checkFileAuth();
        }
      }
    },
    showAuthTipMsg(arg) {
      let tipMsg = '';
      let auth = arg.eventBody.auth;
      switch (auth) {
        case 'READ':
          tipMsg = intl.$t("你在此文档的权限变更为仅查看");
          break;
        case 'READ_DOWNLOAD':
          tipMsg = intl.$t("你在此文档的权限变更为查看和下载");
          break;
        case 'WRITE':
          tipMsg = intl.$t("你在此文档的权限变更为编辑");
          break;
        case 'ALL':
          tipMsg = intl.$t("你在此文档的权限变更为所有权限");
          break;
        default:
          break;}

      if (tipMsg && tipMsg.length > 0) {
        this.$message.info(tipMsg);
      }
    },
    ...mapActions({
      setTreeNodeData: 'kbTreeNodeModule/setTreeNodeData',
      setDocId: 'kbModule/setDocId',
      setDocType: 'kbModule/setDocType',
      setDocView: 'kbModule/setDocView',
      setDocInfo: 'kbEditModule/setDocInfo',
      setWikiSpaceInfo: 'kbModule/setWikiSpaceInfo',
      setEditDocType: 'kbEditModule/setEditDocType',
      onReceiveStatelessMsg: `${HocuspocusModule.moduleSpaceName}${HocuspocusModule.ON_RECEIVE_STATELESS_MSG}`,
      updateSelectDocName: `kbTreeNodeModule/updateSelectDocName`,
      updateSelectDocAuth: `kbTreeNodeModule/updateSelectDocAuth`,
      setIsLoadingTreeNodes: 'kbTreeNodeModule/setIsLoadingTreeNodes',
      setShowAiChat: 'kbModule/setShowAiChat' }),

    async initDir(doc_id) {
      if (!doc_id) {
        return;
      }
      try {
        this.setIsLoadingTreeNodes(true);
        const res: any = await getKBTreeNode(doc_id);
        let { code, data, message }: any = res.data || {};

        // code = 1109;
        if (code == 200) {
          this.setTreeNodeData(data);
        } else {
          if (code !== 116 && code != 109 && code != 1109) {
            this.$message.error(message);
          }
          if (code === 1109) {
            // 显示新的信息，不显示后端返回的错误信息
            this.$message.error(intl.$t("权限不足，请联系管理员添加权限"));
          }
          //区分是否权限不足
          if (code == 601) {
            //展示知识库不存在页面
          } else if (code == 116) {
            let mockdata = {
              wikiSpaceInfo: {},
              treeNodes: [],
              memberIdentity: '',
              fileId: doc_id,
              memberAcl: '' };

            this.setTreeNodeData(mockdata);
          } else if (code == 109) {
            let mockdata = {
              wikiSpaceInfo: {},
              treeNodes: [],
              memberIdentity: '',
              fileId: doc_id,
              memberAcl: '' };

            this.setTreeNodeData(mockdata);
          } else if (code == 1109) {
            // this.setDocView('home')
            // this.setDocType('DOCUMENT')
            data.source = '';
            data.wikiSpaceInfo.space = '';
            data.treeNodes = [];
            this.setTreeNodeData(data);
          } else {
            let mockdata = {
              wikiSpaceInfo: {},
              treeNodes: [],
              memberIdentity: '',
              fileId: doc_id,
              memberAcl: '' };

            this.setTreeNodeData(mockdata);
          }
        }
        this.setIsLoadingTreeNodes(false);
        console.log('目录节点接口数据获取成功: ', data);
      } catch (err) {
        console.log('---------------error:', err);
      }
    },
    gotoSearch() {
      this.showSearch = true;
      setTimeout(() => {
        this.loadSearch();
      }, 100);
    },
    gotoAISearch(searchValue) {
      this.showAISearch = true;
      setTimeout(() => {
        this.openAISearch(searchValue);
      }, 100);
    },
    openAISearch(searchValue = '') {
      updateSaviorData({
        eventtype: 'click',
        category: 'cloud_document',
        label: 'doc_ai_search',
        eventid: 'wiki_web_operation' });

      // 两个不能共存
      this.destroyAi();
      if (this.doc_type !== 'DOCUMENT') {
        // 腾讯文档（销毁 AI 聊天）
        if (this.$refs.tencentDocRef) {
          this.$refs.tencentDocRef.sendMessageToTencentDoc('openAISearch');
        }
      }

      const container = document.getElementById('toca-wiki-ai-search');
      const app: any = document.createElement('toca-wiki-ai-chat');
      // @ts-ignore
      this.aiSearchChat = new TocaWikiAiChat(container, {
        ignoreLocalStorage: true,
        wikiSpaceId: this.wikiSpaceInfo.wikiSpaceId,
        defaultQuestion: searchValue,
        defaultOpen: true,
        fullWidth: true,
        hideHeaderTags: true,
        hidePromptSuggestions: true,
        defaultContentType: 'KnowledgeSearch',
        env: import.meta.env.MODE,
        documentId: 'random' + Math.random(),
        locale: this.wikiI18n,
        saviorEventUUID: saviorEventUUID,
        setSaviorConfigure: setSaviorConfigure,
        updateSaviorData: updateSaviorData,
        aiChatShow: (isShow: Boolean) => {} });

      this.aiSearchChat.resetCache();
      container.appendChild(app);
      window.addEventListener(
      'closeAiChatCustomEvent',
      this.handleCloseAiChatCustomEvent);

    },
    handleCloseAiChatCustomEvent() {
      this.aiSearchChat?.resetDefaultQuestion();
      this.showAISearch = false;
    },
    closeAISearch() {
      this.aiSearchChat?.resetDefaultQuestion();
      this.aiSearchChat?.destroy();
      this.aiSearchChat = null;
      this.aiEntry?.destroy();
      this.aiEntry = null;
      const container = document.getElementById('toca-wiki-ai-search');
      container.innerHTML = '';
      if (this.showAiEntry() === true) {
        this.loadWikiAiChat();
        this.loadWikiAiEntry();
      }

      if (this.doc_type !== 'DOCUMENT') {
        // 腾讯文档
        if (this.$refs.tencentDocRef) {
          this.$refs.tencentDocRef.sendMessageToTencentDoc('closeAISearch');
        }
      }

      window.removeEventListener(
      'closeAiChatCustomEvent',
      this.handleCloseAiChatCustomEvent);

    },
    async loadSearch() {
      let that = this;
      const cookies = {
        token: store.state.userModule.token,
        spaceId: store.state.userModule.spaceId,
        userId: store.state.userModule.userId,
        deviceId: store.state.userModule.deviceId,
        memberUniqueId: store.state.userModule.userDetail?.id,
        memberId: store.state.userModule.userDetail?.id };

      const param = {
        env: import.meta.env.MODE,
        cookies: cookies,
        isSearchKB: true,
        kbId: store.state.kbModule.wikiSpaceInfo?.wikiSpaceId,
        kbName: store.state.kbModule.wikiSpaceInfo?.wikiSpaceName,
        savior: {
          setSaviorConfigure: setSaviorConfigure,
          updateSaviorData: updateSaviorData },

        customContainerClass: 'wiki-home-search-custom-container-class',
        onSearchResultOpen: (url: string, target: string) => {
          console.log(
          '-------------------onSearchResultOpen',
          url,
          target);

          UrlRouterUtil.openUrl(url, target);
        },
        onCloseSearch() {
          console.log('-------------------onCloseSearch');
          that.showSearch = false;
        },
        locale: this.wikiI18n };


      await import('@toca/toca-doc-web-search/dist/style.css');
      const TocaDocWebSearchModule = await import(
      '@toca/toca-doc-web-search');

      const TocaDocWebSearch = TocaDocWebSearchModule.TocaDocWebSearch;
      this.tocaSearch = new TocaDocWebSearch('#toca_doc_search', param);
      // 扩展AI搜索入口
      this.appendAISearchEntryButton();
    },
    appendAISearchEntryButton() {
      const tocaDocSearchContainer = document.getElementById(
      'toca_doc_search');

      if (tocaDocSearchContainer) {
        const tocaDocSearchInput = tocaDocSearchContainer.querySelector(
        'input');

        if (tocaDocSearchInput) {
          const div = document.createElement('div');
          div.className = 'toca-wiki-ai-search-entry-append-to-input';
          // 扩展到input后面
          tocaDocSearchInput.insertAdjacentElement('afterend', div);
          // @ts-ignore
          if (window.TocaWikiAiSearchEntry) {
            // @ts-ignore
            new window.TocaWikiAiSearchEntry(div, {
              onClick: (e) => {
                e.stopPropagation();
                e.preventDefault();
                this.tocaSearch?.destroy &&
                this.tocaSearch?.destroy();
                this.tocaSearch = null;
                this.showSearch = false;
                const searchValue = tocaDocSearchInput.value;
                this.gotoAISearch(searchValue);
              } });

          }
        }
      }
    },
    foldKBDir(isKBDirExpand) {
      this.$refs.tencentDocRef.sendMessageToTencentDoc('foldKBDir');
    },
    starFile() {
      this.$refs.tencentDocRef.sendMessageToTencentDoc('starFile');
    },
    unstarFile() {
      this.$refs.tencentDocRef.sendMessageToTencentDoc('unstarFile');
    },
    getMoreAuth() {
      this.$refs.tencentDocRef.sendMessageToTencentDoc('getMoreAuth');
    },
    async loadWow() {
      await import('@toca/toca-wow/dist/style.css');
      const TocaWowModule = await import('@toca/toca-wow');
      const TocaWow = TocaWowModule.default;
      let that = this;
      const href = window.location.href;
      let envStr = 'production';
      if (href.indexOf('qa') !== -1) {
        envStr = 'qa';
      } else if (href.indexOf('.t.') !== -1) {
        envStr = 'test';
      }
      try {
        const wowId =
        href.indexOf('qa') !== -1 ?
        '1826881623375687681' :
        '1826882347125886977';
        this.tocaWow = new TocaWow('#tocaWow', {
          id: wowId,
          env: envStr,
          isPcMode: true,
          userInfo: {
            userId: store.state.userModule.userId,
            token: store.state.userModule.token,
            deviceId: store.state.userModule.deviceId,
            memberId: store.state.userModule.userDetail?.id,
            spaceId: store.state.userModule.spaceId },

          deviceType: 'WEB', // PC、WEB、H5
          close: () => {
            if (that.tocaWow) {
              that.tocaWow.destroy();
              that.tocaWow = null;
            }
          } });

      } catch (e) {
        console.log('-------------------------------error:', e);
      }
    },
    showCreateFileWithTemplateDialog(templateId) {
      updateSaviorData({
        eventtype: 'click',
        category: 'cloud_document',
        label: 'new_fromTemplateDoc',
        eventid: 'Template_opreation',
        value: {
          fid: this.doc_id } });


      this.isShowFolderOperationDialog = true;
      setTimeout(() => {
        const params = {
          sourceType: 'WIKI',
          operationType: 'CREATE_WITH_TEMPLATE',
          targetTypes: ['MY_DOC', 'SHARE_TO_ME', 'WIKI'],
          sourceFileData: { ...this.doc_info, ...this.doc_info.fileInfo },
          userInfo: { userId: this.userId, spaceId: this.spaceId },
          sourceWikiSpaceId: this.wikiSpaceInfo.wikiSpaceId,
          locale: this.wikiI18n,
          env: import.meta.env.MODE,
          onCancel: () => {
            this.isShowFolderOperationDialog = false;
          },
          onSelectFile: (data) => {
            if (this.doc_info.fileInfo.contentType === 'DOCUMENT') {
              window['tocaEditor']?.saveDocument(
              debounce((result: boolean) => {
                this.createFileWithTemplate(data);
              }, 100));

            } else {
              this.createFileWithTemplate(data);
            }
          } };


        this.folderOperationDialog = new TocaFolderOperationDialog(
        '#toca_folder_operation_dialog',
        params);

      }, 0);
    },

    async createFileWithTemplate(data) {
      const createNameText = data.createNameText;
      const selectedProductType = data.selectedProductType;
      const sourceFileData = data.sourceFileData;
      const selectedNode = data.selectedNode;
      const fileName = sourceFileData.fileName || '';
      let suffix = fileName.includes(".") ? fileName.slice(fileName.lastIndexOf(".") + 1) : "";
      if (sourceFileData.contentType === 'DOCUMENT') {
        suffix = '';
      } else {
        suffix = suffix.length > 0 ? '.' + suffix : '';
      }
      if (selectedProductType === 'WIKI_FILE') {
        // const res = await kbCreateCopy(sourceFileData.fileId,selectedNode.fileId,createNameText + suffix);
        const res = await kbCreateFile('WIKI_FILE', sourceFileData.contentType, selectedNode.fileId, sourceFileData.fileId, createNameText + suffix);
        const { code, message } = res.data;
        const fileId = res.data.data.fileId;
        const contentType = sourceFileData.contentType;
        if (code === 200) {
          if (this.currentWikiSpaceId !== selectedNode.wikiSpaceId) {
            window.open(res.data.data.fileUrl, '_blank');
          } else {
            const res = await getKBTreeNode(fileId);
            const { code, data, message } = res.data;
            if (code == 200) {
              store.dispatch('kbTreeNodeModule/setTreeNodeData', data);
              store.dispatch('kbModule/setWikiSpaceInfo', data.wikiSpaceInfo);
              store.dispatch('kbModule/setDocType', contentType);
              this.refreshDirExpAndSelect(fileId);
            }
          }
          this.$message.success({ content: intl.$t("创建文件成功") });
          this.isShowFolderOperationDialog = false;
        } else {
          this.$message.error({ content: intl.$t("创建文件失败") });
          console.error(message);
        }
      } else if (selectedProductType === 'CLOUD_DOCUMENT') {
        kbCreateDocumentFile(
        'CLOUD_DOCUMENT',
        sourceFileData.fileId,
        sourceFileData.contentType,
        selectedNode.fileId,
        createNameText + suffix).

        then((res) => {
          const { data, code } = res.data;
          if (code === 200) {
            window.open(data.fileUrl, '_blank');
          } else {
            this.$message.error(intl.$t("创建文件失败"));
          }
        }).
        catch((err) => {
          this.$message.error(intl.$t("创建文件失败"));
        });
      }
    },

    async refreshDir(id, curNodeData) {
      const res = await getKBTreeNode(id);
      const { code, data, message } = res.data;
      if (code == 200) {
        store.dispatch('kbTreeNodeModule/setTreeNodeData', data);
        store.dispatch('kbModule/setWikiSpaceInfo', data.wikiSpaceInfo);
        store.dispatch('kbModule/setDocType', curNodeData.contentType);
        this.refreshDirExpAndSelect(id);
      }
    } },

  unmounted() {
    this.fileSocket.wsClose();
  } };
</script>

<style lang="scss" scoped>
.main_view {
    display: flex;
    width: 100%;
    height: 100vh;
    position: relative;

    .loading_view,
    .no_kb_view {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .history_view {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: #fff;
        z-index: 200000;
    }
    .history_view,
    .home_view,
    .setting_view,
    .trash_view {
        flex: 1;
        display: flex;
        min-width: 0;

        .render_view {
            flex: 1;
            display: flex;
            min-width: 0;
            // user-select: none;
        }
    }

    .toca_doc_search {
        z-index: 2000;
        position: fixed;
        width: 100%;
        height: 100%;
    }

    .toca_folder_operation_dialog {
        z-index: 1001;
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #12131728;
    }
}
</style>

<style lang="scss">
body {
    // min-width: 800px;
    overflow: auto;
    background: #fff;
}

body::-webkit-scrollbar {
    display: none;
}

*:focus-visible {
    outline: none;
}

.main_view {
    .arco-tooltip {
        .arco-trigger-popup-wrapper {
            .custom_tooltip_css {
                border-radius: 8px !important;
                color: #767c85 !important;
                font-size: 14px !important;
                font-weight: 400 !important;
                padding: 8px !important;
                background-color: #ffffff !important;
                box-shadow: 0 8px 12px 0 #1213171a !important;
            }

            .custom_tooltip_css_arrow {
                background-color: transparent !important;
            }
        }
    }
}
.full-width {
    width: 100%;
}
.full-height {
    height: 100%;
}
.toca-wiki-ai-search {
    border-radius: 16px;
    overflow: hidden;
}
.wiki-home-search-custom-container-class {
    position: relative;
    .searchInput {
        border: 1px solid #e5e5e5 !important;
        border-radius: 6px;
        padding: 0 8px;
    }
}
.toca-wiki-ai-search-entry-append-to-input {
    position: absolute;
    right: 63px;

    & > div:first-child {
        width: 120px !important;
    }
}

.toca-wiki-ai-search-entry{
    width: unset !important;
}

.toca-wiki-ai-search-entry:hover {
    background-image: linear-gradient(
        90deg,
        #d6d6ff 0%,
        #dfedff 100%
    ) !important;
}
</style>
